import AutocompleteMui from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';

export const AutocompleteStyled = styled(AutocompleteMui, { label: 'AutocompleteAsyncWithCheckboxes' })(() => ({
  '& .MuiInputBase-root': {
    flexWrap: 'nowrap',
  },
})) as typeof AutocompleteMui;
